// 墙
import rlModel from "./rlModel";
import store from "@/store/index";
import { resetRlModules } from "@/mixins/LiteModuleDb.js";

class rlWall extends rlModel {
  constructor() {
    super();
    this.componentType = "wall";
    this.points = []; // 顶点数据

    this.m_gridData = {}; //关联的网格数据
    // this.m_sectParamData = {}; //墙截面数据
    // this.SectData = []; //墙截面组合数据

    this.Ecc = null; //墙偏轴距离
    this.HDiff1 = null; //墙顶标高 1
    this.HDiff2 = null; //墙顶标高 2
    this.HDiffB = null; //墙底高（mm）

    this.Attribute = 1; //默认为主要构件
    this.classTypeName = "rlWallSeg"; // 墙

    this._threeObj = null; ////三维图形对象

    this.Color = new THREE.Color("#ffff00");
    this.ModelType = "墙";
    // this.defaultColor = "#ffff00"; //默认颜色
    // this.Color =
    //   (this.rlLayer && this.rlLayer[2] && this.rlLayer[2].storey) || "#ffff00"; //构件颜色
    // this.Layer = "rlWallSeg"; //图层名称
    this.LinkGuids = null; //能合并为同一条梁的其他梁的guid
    this.m_groupName = "rlWallGroup"; //组名

    // wasm接口方法
    this.getPKPM_WallData =
      store.state.globalData.rl_wasm_module.getPKPM_WallData;
  }

  // 自定义对象在绘制时会重新创建
  create() {
    return new this.constructor();
  }

  initData(obj) {
    super.initData(obj);

    this.m_gridData = obj.m_gridData;

    // const wallSect = obj.wallSect;
    this.Ecc = obj.Ecc;
    this.HDiff1 = obj.HDiff1;
    this.HDiff2 = obj.HDiff2;
    this.HDiffB = obj.HDiffB;

    this.Color = obj.Color ? obj.Color : "#ffff00";
    this.LinkGuids = obj.LinkGuids;
  }

  //用于撤销回退
  reDraw(obj) {
    super.reDraw(obj);
    this.m_gridData = rlAppObj.rlMxDrawObject.getMxEntity(obj.m_gridData);
    this.Ecc = obj.Ecc;
    this.HDiff1 = obj.HDiff1;
    this.HDiff2 = obj.HDiff2;
    this.HDiffB = obj.HDiffB;
  }

  // 添加
  add(obj) {
    const beamParams = obj.beamParams;

    this.ID = obj.ID;
    this.Name = obj.Name;
    this.Guid = obj.Guid;
    this.rlFloorData = obj.rlFloorData;

    this.m_sectParamData = obj.m_sectData;
    this.m_gridData = obj.m_gridData;
    this.Ecc = beamParams.Ecc;
    this.HDiff1 = beamParams.HDiff1;
    this.HDiff2 = beamParams.HDiff2;
    this.HDiffB = beamParams.HDiffB;
    this.LevelB = beamParams.LevelB;
    this.Height = Number(beamParams.Height);

    this.ModelNo = obj.ModelNo;

    // this.Color = beamParams.Color ? beamParams.Color : "#ffff00";
    // this.Layer = beamParams.Layer ? beamParams.Layer : "rlWallSeg";
    this.Strength = obj.Strength ? obj.Strength : null;
    this.StrengthOther = obj.StrengthOther ? obj.StrengthOther : null;
  }

  // 数据转换
  convert() {
    let res = this.getPKPM_WallData(
      this.m_sectParamData.Kind,
      this.m_sectParamData.B,
      this.m_gridData.m_stJoint.m_pt[0],
      this.m_gridData.m_stJoint.m_pt[1],
      this.m_gridData.m_edJoint.m_pt[0],
      this.m_gridData.m_edJoint.m_pt[1],
      this.LevelB,
      this.Height,
      this.Ecc,
      this.HDiff1,
      this.HDiff2,
      this.HDiffB,
      this.m_sectParamData.H
    );
    this.getModelDrawData(JSON.parse(res));

    this.m_sectGroupName = this.m_sectParamData.B.toString();
  }

  // wasm截面数据转换
  getModelDrawData(modelData) {
    this.points = modelData.Points;
    this.index3dData = modelData["3D"]["3dFaces"]
      .map((item) => item.index)
      .flat();
    this.index2dData = modelData["2DUpView"];
    this.SectData = modelData["SectData"];
  }

  // 克隆
  async myClone() {
    let newObj = await super.myClone();

    newObj.m_gridData = this.m_gridData;
    newObj.Ecc = this.Ecc;
    newObj.HDiff1 = this.HDiff1;
    newObj.HDiff2 = this.HDiff2;
    newObj.HDiffB = this.HDiffB;

    newObj.points = this.points;
    return newObj;
  }

  // 绘制
  worldDraw(pWorldDraw) {
    this.convert();
    if (pWorldDraw.mxObj._is2d) {
      pWorldDraw.setColor(new THREE.Color(this.Color));
      this.create2dModel(this.index2dData, pWorldDraw);
    }
    this._threeObj = this.create3dModel(
      this.points,
      this.index3dData,
      0.000003,
      5
    );
    this.m_gridData.m_wallId = this.objectId();
  }

  // 输出同理
  dwgOut(obj) {
    this.onDwgOut(obj);
    return obj;
  }

  // 数据读入
  dwgIn(obj) {
    this.onDwgIn(obj);
    return true;
  }

  getDataBase() {
    let data = super.getDataBase();
    data["SectGuid"] = this.m_sectParamData.Guid;

    if (this.m_gridData) data["GridGuid"] = this.m_gridData.Guid;

    data["Ecc"] = this.Ecc;
    data["HDiff1"] = this.HDiff1;
    data["HDiff2"] = this.HDiff2;
    data["HDiffB"] = this.HDiffB;
    data["LinkGuids"] = this.LinkGuids;
    return data;
  }

  //获取图形绘制数据--用于撤销回退
  getDrawData() {
    let data = super.getDrawData();

    data["m_gridData"] = this.m_gridData.objectId();
    data["Ecc"] = this.Ecc;
    data["HDiff1"] = this.HDiff1;
    data["HDiff2"] = this.HDiff2;
    data["HDiffB"] = this.HDiffB;

    return data;
  }

  // 删除
  erase() {
    this.m_gridData ? (this.m_gridData.m_wallId = null) : "";
    super.erase();
  }

  // // 偏移
  // transformBy () {
  //   // 定义平移的偏移量
  //   const offsetX = 10000
  //   const offsetY = 0
  //   const offsetZ = 0
  //   // 对每个坐标进行平移操作
  //   for (let i = 0; i < this.index2dData.length; i += 3) {
  //     this.index2dData[i] += offsetX // 平移 x 坐标
  //     this.index2dData[i + 1] += offsetY // 平移 y 坐标
  //     this.index2dData[i + 2] += offsetZ // 平移 z 坐标
  //   }
  //   // 对每个坐标进行平移操作
  //   for (let i = 0; i < this.points.length; i += 3) {
  //     this.points[i] += offsetX // 平移 x 坐标
  //     this.points[i + 1] += offsetY // 平移 y 坐标
  //     this.points[i + 2] += offsetZ // 平移 z 坐标
  //   }
  // }
}

export { rlWall };
